// Emails allowed to create / edit / delete blog posts.
// NOTE: this only hides the authoring UI on the client. For real protection,
// mirror this list in your Firestore security rules (see README / plan notes).
export const ADMIN_EMAILS = ["vermasuraj008@gmail.com"];

export const isAdmin = (user) =>
  !!user?.email && ADMIN_EMAILS.includes(user.email.toLowerCase());

// Rough read-time estimate based on ~200 words per minute.
export const readTime = (content = "") => {
  const words = content.trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
};

// Formats a Firestore timestamp (or Date / millis) into "Jul 4, 2026".
export const formatDate = (value) => {
  if (!value) return "";
  const date =
    typeof value?.toDate === "function"
      ? value.toDate()
      : new Date(value?.seconds ? value.seconds * 1000 : value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};
